export enum AddressTypeEnum {
  Billing = 'billing',
  Delivery = 'delivery',
  Pickup = 'pickup'
}
